import { Box, Tooltip, Typography } from '@mui/material';
import { useSimulateActions, useSimulateMeta } from '../SimulateTradeContext';
import { SIMULATE_COPY } from '../content';
import { SimulateTradeIcon } from './SimulateTradeIcon';

interface Props {
  fontSize?: { md?: number; sm?: number; xs?: number } | number;
  disabled?: boolean;
  disabledReason?: string;
}

export const SimulateTradeLink = ({ fontSize = { md: 14, sm: 13, xs: 12 }, disabled: disabledProp = false, disabledReason }: Props) => {
  const { open } = useSimulateActions();
  const { masterAccountId, slaveAccountId } = useSimulateMeta();

  const accountsMissing = !masterAccountId || !slaveAccountId;
  const disabled = accountsMissing || disabledProp;
  const tooltip = accountsMissing
    ? SIMULATE_COPY.block.accountsShort
    : disabledProp
    ? disabledReason || SIMULATE_COPY.block.riskSettings
    : '';

  const content = (
    <Box display="flex" alignItems="center" gap={0.5} sx={{ opacity: disabled ? 0.6 : 1 }}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          fontSize: fontSize,
          lineHeight: 1,
          color: (theme) => (disabled ? theme.palette.text.disabled : theme.palette.primary.main)
        }}
      >
        <SimulateTradeIcon size={16} />
      </Box>
      <Typography variant="body2" color="text.secondary" fontSize={fontSize} lineHeight="100%">
        Want to simulate the trade,{' '}
        <Typography
          variant="body2"
          component="span"
          color={disabled ? 'text.disabled' : 'primary'}
          sx={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
          fontSize={fontSize}
          lineHeight="100%"
          onClick={disabled ? undefined : open}
        >
          simulate now
        </Typography>
      </Typography>
    </Box>
  );

  if (disabled) {
    return (
      <Tooltip title={tooltip}>
        <span>{content}</span>
      </Tooltip>
    );
  }
  return content;
};
